import { render } from "./PostCardEvent.vue?vue&type=template&id=766c88c5"
import script from "./PostCardEvent.vue?vue&type=script&lang=js"
export * from "./PostCardEvent.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/derolfgroep-ict/derolfgroep-ict/web/app/themes/rolfhardware/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__